@if (depositMetadata(); as deposit) {
  <div
    class="m-0 box-border flex w-full flex-col gap-4 overflow-auto rounded-md bg-white p-4 shadow-md shadow-slate-500/10"
  >
    <div class="flex flex-row items-center justify-between gap-4">
      <h3 class="!m-0 text-base !font-bold">Deposit</h3>
      <pr-deposit-status-chip [deposit]="deposit" />
    </div>

    <ng-content />

    @if (summary(); as summaryText) {
      <pr-information-box>{{ summaryText }}</pr-information-box>
    }

    @if (warning(); as warningText) {
      <div
        class="rounded-md bg-amber-50 p-3 text-sm font-medium text-amber-900"
        role="alert"
      >
        {{ warningText }}
      </div>
    }
  </div>
}
